<!--
  Vue Racine de l'application
  @uteur : Samuel PARFOURU
-->
<style>
  /* https://www.w3schools.com/howto/howto_css_custom_scrollbar.asp */
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: lightgray;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: lightslategray;
  }
</style>
<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
}
</script>
